import { useState } from "react";
import { useForm } from "react-hook-form";
import { DIAMONDS_COLLECTION } from "../../constants";
import db from "../../firebaseConfig";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { setHasMore } from "../../redux/diamond/diamondActions";

const CreateDiamondPage = ({ auth, setHasMore }) => {

    const [loading, setLoading] = useState(false);

    const history = useHistory();

    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = async data => {
        setLoading(true);
        const diamond = {
            diamond: data.diamond,
            price: parseInt(data.price),
            status: false,
            onlyGameAccountId: data.onlyGameAccountId === 'Yes' ? true : false,
            createdBy: auth.user?.email,
            updatedBy: auth.user?.email,
            createdAt: new Date(),
            updatedAt: new Date(),
        };

        await db
        .collection(DIAMONDS_COLLECTION)
        .add(diamond);
        // console.log(diamond);
        setHasMore(true);
        setLoading(false);
        return history.replace("/diamonds");
    };
    
    return (
        <div>
            <div className="flex w-full justify-between bg-blue-400 py-4 px-4 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                <button onClick={() => history.goBack()} className=" text-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                </button>
                <p className="m-auto inset-0 text-xl font-semibold leading-7 text-center text-gray-200">Create New Diamond Card</p>
            </div>
            <form className="bg-blue-400 shadow-lg rounded-lg p-8 m-2 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow-lg" onSubmit={handleSubmit(onSubmit)}>
    
                <div className="relative mb-4">
                    <input  {...register("diamond", { required: true })} type="text" placeholder="Diamonds" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-lg outline-none text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out backdrop-filter backdrop-blur-lg bg-opacity-5 overflow-hidden"/>
                    {/* errors will return when field validation fails  */}
                    {errors.diamond && <span className="text-red-300">This field is required</span>}
                </div>
    
                <div className="relative mb-4">
                    <input  {...register("price", { required: true, pattern: /^[0-9]+$/i })} type="text" placeholder="Price" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-lg outline-none  text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out backdrop-filter backdrop-blur-lg bg-opacity-5 overflow-hidden"/>
                    {/* errors will return when field validation fails  */}
                    {errors.price && <span className="text-red-300">This field is required</span>}
                </div>
    
                <div className="relative mb-4 text-gray-300">
                    <input {...register("onlyGameAccountId", { required: false })} type="checkbox" className="form-checkbox h-4 w-4 text-green-600 mr-2" />
                    Only Game Account ID
                    {/* errors will return when field validation fails  */}
                    {errors.onlyGameAccountId && <span className="text-red-300">This field is required</span>}
                </div>
                
                <button type="submit" className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-center leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
                {loading ? (
                        <>
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Processing
                        </>
                        
                    ) : 'Submit' }
                    
                </button>
            </form>
        </div>
    );
}


const mapStateToProps = state => {
    return {
        auth: state.auth
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setHasMore: (value) => dispatch(setHasMore(value))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(CreateDiamondPage);